import React from 'react'
import commonAction from '../../actions/common'
import { connect } from 'react-redux'
import './WorkOrderDetails.scss'
import WhiteSpace from '../../components/WhiteSpace'
import { getOrderDetail, saveOrder, startOrder, orderDistance, getMaintainConfig } from '../../api/WorkOrderDetails'
import { batchUploadFileByBase64, uploadFileByBase64, uploadFile, getWechatConfig, wxValidationPermissions } from '../../api/Sys'
import { getUserSimpleList } from '@/api/ElevatorMaintenance';
import Tabs from '../../components/Tabs'
import MainSwiper from './components/MainSwiper'
import VideoUploader from '../../components/VideoUploader'
import { ImagePicker, Toast } from 'antd-mobile';
import Drawer from '../../components/Drawer'
import Signature from '../../components/Signature'
import wx from 'weixin-js-sdk'
import Lodding from '../../components/Lodding'
import transformFile from '@/libs/imageCompression'
import Dialog from '@/components/Dialog'
import Select from '../../components/Select'
import { getLiftDetail } from '@/api/LiftLocation'
import { buildTaskExecutedField, hasPendingAssignTask } from './taskExecution'
import { ensureBaiduMap } from '../../libs/baiduMap'

function guid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0,
      v = c == 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}


class WorkOrderDetails extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      detail: {},
      locationDTOList: [],
      locationDTOListName: [],
      scenePhoto: [],
      orderPhoto: [],
      videoFiles: [], // 视频文件列表
      videoUploadProgress: {}, // 视频上传进度
      open: false,
      lat: 0,
      address: "",
      animating: false,
      status: 4, //工单状态
      signatureImage: [],
      remark: '',
      replacementParts: '',
      showDialog: false,
      showStartDialog: false,
      showJuliDialog: false,
      showTimeDialog: false,
      showTimeMsg: false,
      peoples: [],
      peopleList: [], //接口返回的数据
      openSignature3: false,
      juli: null,
      showForceSubmitDialog: false,
      forceSubmitMsg: '是否强制提交？',
      taskExecuted: false,
      distanceConfig: { startDistance: 0, endDistance: 0 }

    }
    this.postData = {}
    // 工单状态 2 中途离开 4 结束
    this.submitStatus = 2
    this.maintainOrderId = null;
    this.canSearch = true
    this.currentPeople = null
    this.lat = null
    this.lon = null

    // 添加全局点击事件来关闭 Toast
    this.handleDocumentClick = this.handleDocumentClick.bind(this);
  }

  componentDidMount() {
    document.addEventListener('click', this.handleDocumentClick);
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleDocumentClick);
  }

  handleDocumentClick = (e) => {
    // 点击页面任何地方时关闭 Toast
    const toastEl = document.querySelector('.am-toast');
    if (toastEl && !toastEl.contains(e.target)) {
      Toast.hide();
    }
  }
  getUserSimpleListFun = async (v = '') => {
    this.canSearch = false
    const res = await getUserSimpleList({ keyword: v, size: 1000, });
    if (res.code === 200) {
      this.setState({
        peopleList: res.data
      })
    }
    this.canSearch = true
  }

  // 搜索项目
  handleSearch = (val) => {
    if (this.canSearch) {
      this.getUserSimpleListFun(val)
    }
  }
  // 下拉框聚焦
  handleFocus = () => {
    this.getUserSimpleListFun()
  }
  // 返回当前选中的值
  handleChoose = (v, item) => {
    let arr = []
    arr = [...this.state.peoples]
    const index = arr.findIndex(i => i.gid === item.gid)
    arr[index].teamworkUserId = v.userId
    arr[index].teamworkUserName = v.nickname
    arr[index].userId = v.userId
    arr[index].nickname = v.nickname
    this.setState({
      peoples: arr
    })
  }

  addItem = () => {
    const arr = [...this.state.peoples]
    const obj = {
      gid: guid(),
      imageUrl: null,
      rate: null,
      teamworkUserId: null,
      teamworkUserName: null
    }
    arr.push(obj)
    this.setState({
      peoples: arr
    })
  }

  moreInputChange = (gid, e) => {
    const arr = [...this.state.accessories]
    const index = arr.findIndex(item => item.gid === gid)
    arr[index].useAmount = e.target.value
    this.setState({
      accessories: arr
    })
  }

  showSig = (item) => {
    this.currentPeople = { ...item }
    this.setState({
      openSignature3: true
    })
  }

  // 获取签名的base64 然后提交服务器
  getSignature3 = async (base64) => {
    this.setState({
      animating: true
    })
    const res1 = await this.submitBase64List()
    if (res1) {
      const res = await uploadFileByBase64(base64)
      if (res.code === 200) {
        // this.submitStatus = 4
        // this.signatureImageDataList.push({ imageUrl: res.data.url })
        // this.getLocation()
        const arr = [...this.state.peoples]
        const index = arr.findIndex(item => this.currentPeople.gid === item.gid)
        arr[index].imageUrl = res.data.url
        this.setState({
          peoples: arr,
          openSignature3: false
        })
      }
    }
    this.setState({
      animating: false
    })
  }

  deleteItem = (gid, type) => {
    let arr = []
    if (type === 'a') {
      arr = [...this.state.accessories]
    } else {
      arr = [...this.state.peoples]
    }
    const index = arr.findIndex(item => item.gid === gid)
    arr.splice(index, 1)
    if (type === 'a') {
      this.setState({
        accessories: arr
      })
    } else {
      this.setState({
        peoples: arr
      })
    }

  }

  componentDidMount() {
    const pathname = this.props.path;
    this.props.dispatch({ type: commonAction.setPathname, pathname })
    this.props.onRef(this);
    this.getWechatConfigFun()
    // this.startOrderFun(this.props.match.params.id * 1)
    this.getOrderDetailFun(this.props.match.params.id * 1)
    this.getMaintainConfigFun()



    this.addItem()
  }

  // 获取维保配置
  getMaintainConfigFun = async () => {
    const res = await getMaintainConfig()
    if (res.code === 200 && res.data && res.data.distanceLimit) {
      this.setState({
        distanceConfig: {
          startDistance: res.data.distanceLimit.startDistance || 0,
          endDistance: res.data.distanceLimit.endDistance || 0
        }
      })
    }
  }

  // 开始工单
  startOrderFun = (orderId) => {
    // 只有首次保养时限制异地
    const { startDistance } = this.state.distanceConfig
    if (startDistance > 0 && this.state.detail.maintainState == 0 && (this.state.juli === null || this.state.juli > startDistance)) {
      this.setState({
        showJuliDialog: true
      })
      return;
    }
    this.getStartOrderLocation(orderId);

  }
  // 获取地理位置
  getStartOrderLocation = async (orderId) => {
    try {
      await ensureBaiduMap()
    } catch (e) {
      Toast.fail(e.message || '未配置百度地图 AK')
      return
    }
    const that = this
    wx.ready(function () {
      wx.checkJsApi({
        jsApiList: ["getLocation"],
        success(res) {
          if (res.checkResult.getLocation === false) {
            const message =
              "你的微信版本太低，不支持微信JS接口，请升级到最新的微信版本！";
            console.log(message);
          } else {
            let postData = {
              orderId
            };
            wx.getLocation({
              type: 'wgs84',
              success: (res) => {
                console.log("getLocation res=", res)
                const BMap = window.BMap
                const ggPoint = new BMap.Point(res.longitude, res.latitude)
                var convertor = new BMap.Convertor();
                var pointArr = [];
                pointArr.push(ggPoint);
                const geoc = new BMap.Geocoder()
                convertor.translate(pointArr, 1, 5, (res) => {
                  if (res.status === 0) {
                    postData.lon = res.points[0].lng
                    postData.lat = res.points[0].lat
                    geoc.getLocation(res.points[0], function (rs) {
                      console.log(rs)
                      if (rs) {
                        postData.address = rs.address
                      }
                      that.startOrderApi(postData)
                    });
                  } else {
                    that.startOrderApi(postData)
                  }
                })
              },
              error: (error) => {
                this.handleLocationError(error)
              }
            })
          }
        },
      })
    })
    wx.error(function (res) {
      console.log(res, 'res')
    })
  }

  startOrderApi = async (params) => {
    const res = await startOrder(params);
    if (res.code !== 200) {
      this.setState({
        showTimeMsg: res.message,
        showTimeDialog: true
      })
    }
  }

  // 判断是不是ios
  isIos = () => {
    const u = navigator.userAgent;
    return u.indexOf("iPhone") > -1 || u.indexOf("Mac OS") > -1;
  }
  submit = () => {
    this.props.history.push({ pathname: `/layout/log/${this.props.match.params.id}` });
  }

  // 获取电梯详情
  getLiftDetailFun = async (liftId) => {
    const res = await getLiftDetail({ liftId })
    if (res.code === 200) {
      this.lat = res.data.lat
      this.lon = res.data.lon
      if (!this.lat || !this.lon) {
        Toast.fail("暂无位置信息", 2)
        return
      }
      try {
        await ensureBaiduMap()
      } catch (e) {
        Toast.fail(e.message || '未配置百度地图 AK')
        return
      }
      const that = this
      wx.ready(function () {
        wx.checkJsApi({
          jsApiList: ["getLocation"],
          success(res) {
            if (res.checkResult.getLocation === false) {
              const message =
                "你的微信版本太低，不支持微信JS接口，请升级到最新的微信版本！";
              console.log(message);
            } else {
              wx.getLocation({
                type: 'wgs84',
                success: (res) => {
                  console.log("getLocation res=", res)
                  const BMap = window.BMap
                  const ggPoint = new BMap.Point(res.longitude, res.latitude)
                  var convertor = new BMap.Convertor();
                  var pointArr = [];
                  pointArr.push(ggPoint);
                  convertor.translate(pointArr, 1, 5, (res) => {
                    if (res.status === 0) {
                      const nowLon = res.points[0].lng
                      const nowLat = res.points[0].lat
                      orderDistance({ lngFrom: nowLon, lngTo: that.lon, latFrom: nowLat, latTo: that.lat }).then((res) => {
                        if (res.code === 200) {
                          that.setState({
                            juli: res.data || null
                          })
                        } else {
                          // API调用失败时，设置juli为null
                          that.setState({
                            juli: null
                          })
                        }
                      }).catch((error) => {
                        // 网络错误或其他异常时，设置juli为null
                        console.error('距离计算失败:', error)
                        that.setState({
                          juli: null
                        })
                      })
                    } else {
                      // 坐标转换失败时，设置juli为null
                      that.setState({
                        juli: null
                      })
                    }
                  })
                },
                error: (error) => {
                  that.handleLocationError(error)
                }
              })
            }
          },
        })
      })
      wx.error(function (res) {
        console.log(res, 'res')
      })
    }
  }

  // 处理位置获取错误
  handleLocationError = (error, callback) => {
    console.log("getLocation error=", error)

    if (error.errMsg === 'getLocation:fail auth deny') {
      Toast.fail('请先开启定位权限')
      return
    }
    if (error.errMsg === 'getLocation:fail') {
      Toast.fail('获取位置信息失败')
      return
    }
    if (error.errMsg === 'getLocation:fail system error') {
      Toast.fail('获取位置信息失败')
      return
    }
    if (error.errMsg === 'getLocation:fail location timeout') {
      Toast.fail('获取位置信息失败')
      return
    }
    if (error.errMsg === 'getLocation:fail location error') {
      Toast.fail('获取位置信息失败')
      return
    }
    if (error.errMsg === 'getLocation:fail network error') {
      Toast.fail('获取位置信息失败')
      return
    }
    // 如果没有匹配的错误类型，执行回调函数
    if (callback && typeof callback === 'function') {
      callback()
    }
  }

  reset = () => {
    this.getLiftDetailFun(window.liftId)
  }

  async getOrderDetailFun(orderId) {
    this.maintainOrderId = orderId;
    const res = await getOrderDetail({ orderId })

    if (res.code === 200) {
      window.liftId = res.data.liftId
      this.getLiftDetailFun(window.liftId)
      let tabsNames = []
      res.data.locationDTOList.forEach(item => {
        tabsNames.push(item.locationName)
      })
      let liveImageDataList = []
      res.data.liveImageDataList.forEach((item, index) => {
        liveImageDataList.push({
          id: index,
          url: item.imageUrl
        })
      })
      let orderImageDataList = []
      res.data.orderImageDataList.forEach((item, index) => {
        orderImageDataList.push({
          id: index,
          url: item.imageUrl
        })
      })

      // 处理视频数据
      let videoFiles = []
      // 优先使用 videoParamList 字段
      if (res.data.videoParamList && res.data.videoParamList.length) {
        videoFiles = res.data.videoParamList.filter(item => item.videoUrl).map((item, index) => ({
          id: index,
          url: item.videoUrl,
          videoUrl: item.videoUrl,
          videoTitle: item.videoTitle || `视频${index + 1}`,
          name: item.videoTitle || `视频${index + 1}`,
          videoStatus: item.videoStatus // 保存videoStatus
        }))
      }
      // 兼容旧数据，如果没有 videoParamList 则使用 videoDataList
      else if (res.data.videoDataList && res.data.videoDataList.length) {
        videoFiles = res.data.videoDataList.map((item, index) => ({
          id: index,
          url: item.videoUrl,
          videoUrl: item.videoUrl,
          name: item.videoName || `视频${index + 1}`,
          videoStatus: item.videoStatus // 保存videoStatus
        }))
      }

      let signatureImage = []
      if (res.data.signatureImageDataList && res.data.signatureImageDataList.length) {
        signatureImage = res.data.signatureImageDataList
      }
      const peoples = res.data.maintainOrderTeamworkList.map(item => ({ ...item, gid: guid(), userId: item.teamworkUserId, nickname: item.teamworkUserName }))
      console.log(peoples)
      this.setState({
        detail: res.data,
        locationDTOList: res.data.locationDTOList,
        locationDTOListName: tabsNames,
        scenePhoto: liveImageDataList,
        orderPhoto: orderImageDataList,
        videoFiles: videoFiles, // 添加视频文件到状态
        status: res.data.status,
        signatureImage,
        replacementParts: res.data.replacementParts || '',
        peoples,
        remark: res.data.remark || '',
        taskExecuted: false
      }, () => { this.checkOrder(); this.getUserSimpleListFun(); })
    }
  }
  format = (num) => {
    let str = num >= 10 ? num : '0' + num
    return str
  }
  checkOrder = () => {
    const needDate = new Date()
    let needYear = needDate.getFullYear()
    let needMonth = this.format(needDate.getMonth() + 1)
    let needDay = this.format(needDate.getDate())
    let date = `${needYear}-${needMonth}-${needDay}`
    if (this.state.detail.status !== 4 && date !== this.state.detail.planTime) {
      this.setState({
        showDialog: true
      })
    } else {
      this.setState({
        showStartDialog: true
      })
    }

  }

  handleCancle = () => {
    this.props.history.goBack(-1)
  }

  handleConfirm = () => {
    this.setState({
      showDialog: false
    })
    this.startOrderFun(this.props.match.params.id * 1)
  }

  handleJuliConfirm = () => {
    this.setState({
      showJuliDialog: false
    })
  }

  handleForceSubmitConfirm = () => {
    this.save(false)
    this.setState({
      showForceSubmitDialog: false
    })
  }

  handleForceSubmitCancel = () => {
    this.setState({
      showForceSubmitDialog: false
    })
    this.setState({
      animating: false,
      open: false
    })
  }

  handleStartConfirm = () => {
    this.setState({
      showStartDialog: false
    })
    this.startOrderFun(this.props.match.params.id * 1)
  }

  onMainSwiperRef = (ref) => {
    this.mainSwiper = ref
  }

  onTabsRef = (ref) => {
    this.tabs = ref
  }

  changeTab = (index) => {
    if (this.mainSwiper) {
      this.mainSwiper.changeSlide(index);
    }
  }

  touchIndex = (index) => {
    this.tabs.changeSwuper(index)
  }


  scenePhotoChange = async (files, type, index) => {
    this.setState({
      scenePhoto: files
    })
  }

  orderPhotoChange = (files, type, index) => {
    this.setState({
      orderPhoto: files
    })
  }

  // 弹出签名弹窗
  clickSubmit = async () => {
    // 结束提交异地校验
    const { endDistance } = this.state.distanceConfig
    if (endDistance > 0 && (this.state.juli === null || this.state.juli > endDistance)) {
      Toast.fail("异地不能提交，距离" + (this.state.juli === null ? '--' : this.state.juli) + "米", 2)
      return
    }
    // 检查视频上传状态
    if (this.state.detail.videoStatus === 20 && this.state.detail.videoParamList && this.state.detail.videoParamList.length > 0) {
      // 检查是否所有必需的视频都已上传
      const requiredVideos = this.state.detail.videoParamList.length;
      const uploadedVideos = this.state.videoFiles.length;

      if (uploadedVideos < requiredVideos) {
        Toast.fail(`视频必须全部上传，还有${requiredVideos - uploadedVideos}个视频未上传`, 2)
        return
      }
    }
    if (this.state.peoples.length == 0 && this.state.detail.maintainType > 1) {
      Toast.fail("请添加协同人", 2)
      return
    }

    var flag = this.state.peoples.filter(
      s => (s == null || s == undefined || s.imageUrl == null || s.imageUrl == undefined || s.imageUrl == '')
    );
    if (flag.length > 0) {
      Toast.fail("协同人请签字", 2)
      return
    }



    const lists = this.mainSwiper.getNewData()
    let str = ''
    lists.some(list => {
      const item = list.itemDTOList.find(item => item.optionalStatus == 1 && !item.result)
      if (item) {
        str = `"${list.locationName}"_"${item.itemName}"_"${item.requirements}"必须选择`
        return true
      }
    })
    console.log(str)
    if (str) {

      Toast.fail(str, 5)

      return
    }

    this.setState({
      open1: true
    })

  }

  // 签完字确定后保存数据
  save = async (checkFlag = true) => {
    this.postData.submitStatus = this.submitStatus
    this.postData.remark = this.state.remark
    this.postData.replacementParts = this.state.replacementParts
    this.postData.taskExecuted = buildTaskExecutedField(this.submitStatus, this.state.taskExecuted)
    this.postData.signatureImageDataList = this.signatureImageDataList
    this.postData.orderTeamworkParamList = this.state.peoples
    if (this.maintainOrderId) {
      this.postData.orderId = this.maintainOrderId;
    }
    const res = await saveOrder({ ...this.postData, checkFlag })
    if (res.code === 200) {
      Toast.success("保存成功", 2)
      this.setState({
        animating: false,
        open: false
      }, () => {
        this.props.history.goBack()
      })
    } else if (res.code === 2305 && checkFlag) {
      // 显示确认弹窗
      Toast.info(res.message || '提交失败，是否强制提交？', 2)
      this.setState({
        showForceSubmitDialog: true,
        forceSubmitMsg: res.message || '是否强制提交？'
      })
    } else {
      Toast.fail(res.message || "保存失败", 2)
      this.setState({
        animating: false,
        open: false
      })
    }

  }

  // 关闭弹窗
  handleClose = async (v) => {
    this.setState({
      ['open' + v]: false
    })
  }

  // 获取签名的base64 然后提交服务器
  getSignature2 = async (base64) => {
    this.setState({
      animating: true
    })
    const res1 = await this.submitBase64List()
    if (res1) {
      const res = await uploadFileByBase64(base64)
      if (res.code === 200) {
        this.submitStatus = 4
        this.signatureImageDataList.push({ imageUrl: res.data.url })
        this.getLocation()
        this.postData.lon = 120.298501
        this.postData.lat = 30.41875
        this.postData.address = '余杭区'
        this.save()
      }
    }
  }

  // 获取签名的base64 然后提交服务器
  getSignature = async (base64) => {
    this.setState({
      animating: true
    })
    const res1 = await this.submitBase64List()
    if (res1) {
      const res = await uploadFileByBase64(base64)
      if (res.code === 200) {
        this.signatureImageDataList = [{ imageUrl: res.data.url }]
      }
      this.submitStatus = 4
      this.getLocation()
      //本地调试 绕过 地址交验
      //  this.postData.lon = 120.298501
      //   this.postData.lat = 30.41875
      //   this.postData.address = '余杭区'
      //   this.save()
    }

    // this.setState({
    //   animating: false,
    //   open2: true
    // })
  }
  // 提交base64图片到服务器
  submitBase64List = async (checkFlag = true) => {
    this.postData = { ...this.state.detail }
    this.postData.locationDTOList = await this.mainSwiper.getNewData()
    let orderImageDataList = []
    let liveImageDataList = []
    let orderImageBase64ListFinish = []
    let liveImageBase64ListFinish = []
    let videoDataList = [] // 视频数据列表

    // 处理工单照片
    if (this.state.orderPhoto && this.state.orderPhoto.length) {
      const orderImageBase64List = []

      for (let i = 0; i < this.state.orderPhoto.length; i++) {
        if (this.state.orderPhoto[i].file) {
          orderImageBase64List.push(await transformFile(this.state.orderPhoto[i]))
        } else {
          orderImageBase64ListFinish.push({
            imageType: 2,
            imageUrl: this.state.orderPhoto[i].url
          })
        }
      }

      const orderImageDataListRes = await batchUploadFileByBase64({ base64List: orderImageBase64List, checkFlag })
      if (orderImageDataListRes.code === 200) {
        orderImageDataList = orderImageDataListRes.data.map(item => {
          const obj = {
            imageType: 2,
            imageUrl: item.url
          }
          return obj
        })
      } else if (orderImageDataListRes.code === 2305 && checkFlag) {
        // 显示确认弹窗
        Toast.info(orderImageDataListRes.message || '提交失败，是否强制提交？', 2)
        this.setState({
          showForceSubmitDialog: true,
          forceSubmitMsg: orderImageDataListRes.message || '是否强制提交？'
        })
        return false
      }
    }

    // 处理现场照片
    if (this.state.scenePhoto && this.state.scenePhoto.length) {
      const liveImageBase64List = []
      for (let i = 0; i < this.state.scenePhoto.length; i++) {
        if (this.state.scenePhoto[i].file) {
          liveImageBase64List.push(await transformFile(this.state.scenePhoto[i]))
        } else {
          liveImageBase64ListFinish.push({
            imageType: 2,
            imageUrl: this.state.scenePhoto[i].url
          })
        }
      }
      const liveImageDataListRes = await batchUploadFileByBase64({ base64List: liveImageBase64List, checkFlag })
      if (liveImageDataListRes.code === 200) {
        liveImageDataList = liveImageDataListRes.data.map(item => {
          const obj = {
            imageType: 1,
            imageUrl: item.url
          }
          return obj
        })
      } else if (liveImageDataListRes.code === 2305 && checkFlag) {
        // 显示确认弹窗
        Toast.info(liveImageDataListRes.message || '提交失败，是否强制提交？', 2)
        this.setState({
          showForceSubmitDialog: true,
          forceSubmitMsg: liveImageDataListRes.message || '是否强制提交？'
        })
        return false
      }
    }

    // 处理视频文件上传
    if (this.state.videoFiles && this.state.videoFiles.length) {
      try {
        for (let i = 0; i < this.state.videoFiles.length; i++) {
          const videoItem = this.state.videoFiles[i];

          // 添加视频信息到列表（视频已在选择时上传到服务器）
          videoDataList.push({
            videoType: 1,
            videoUrl: videoItem.videoUrl || videoItem.url,
            videoName: videoItem.name || videoItem.videoTitle
          });
        }
      } catch (error) {
        console.error('视频处理错误:', error);
        Toast.fail('视频处理失败', 2);
      }
    }

    // 准备 videoParamList 数据
    let videoParamList = [];
    if (this.state.detail.videoParamList && this.state.detail.videoParamList.length) {
      // 使用原始的videoParamList结构，但更新URL
      videoParamList = this.state.detail.videoParamList.map(item => {
        // 查找对应的已上传视频
        const uploadedVideo = this.state.videoFiles.find(v => v.videoTitle === item.videoTitle);
        return {
          videoTitle: item.videoTitle || '',
          videoUrl: uploadedVideo ? (uploadedVideo.videoUrl || uploadedVideo.url) : item.videoUrl || '',
          videoStatus: item.videoStatus // 保留原始的videoStatus
        };
      });
    } else if (this.state.videoFiles && this.state.videoFiles.length) {
      // 如果没有原始结构，则从上传的视频创建
      videoParamList = this.state.videoFiles.map(videoItem => ({
        videoTitle: videoItem.videoTitle || videoItem.name || '',
        videoUrl: videoItem.videoUrl || videoItem.url || '',
        videoStatus: this.state.detail.videoStatus // 从详情中获取videoStatus
      }));
    }

    this.postData.orderImageDataList = orderImageBase64ListFinish.concat(orderImageDataList)
    this.postData.liveImageDataList = liveImageBase64ListFinish.concat(liveImageDataList)
    this.postData.videoDataList = videoDataList // 添加视频数据到提交数据中
    this.postData.videoParamList = videoParamList // 添加新的视频参数列表
    this.postData.videoStatus = this.state.detail.videoStatus // 添加视频状态字段
    this.postData.videoTitle = this.state.detail.videoTitle // 添加视频标题字段

    // 设置视频URL，如果有视频则使用第一个视频的URL
    if (videoDataList && videoDataList.length > 0) {
      this.postData.videoUrl = videoDataList[0].videoUrl;
    } else {
      this.postData.videoUrl = '';
    }
    return true
  }
  // 中途离开
  liveSubmit = async () => {
    // if (this.state.juli === null || this.state.juli > 600) {
    //   Toast.fail("异地不能提交", 2)
    //   return
    // }
    this.setState({
      animating: true
    })
    this.submitStatus = 2
    if (await this.submitBase64List()) {
      //本地调试 绕过 地址交验
      this.getLocation()
      // this.postData.lon = 120.298501
      // this.postData.lat = 30.41875
      // this.postData.address = '余杭区'
      // this.save()
    }
  }

  // 获取授权
  getWechatConfigFun = async () => {
    console.log('授权发起')
    let url = window.location.href.split("#")[0];
    if (this.isIos()) {
      url = localStorage.getItem('url')
    }
    const res = await getWechatConfig(url)
    if (res.code === 200) {
      const data = { ...res.data }
      data.jsApiList = ['getLocation']
      wxValidationPermissions(data)
    }
  }

  // 获取地理位置
  getLocation = async () => {
    try {
      await ensureBaiduMap()
    } catch (e) {
      Toast.fail(e.message || '未配置百度地图 AK')
      return
    }
    const that = this
    wx.ready(function () {
      wx.checkJsApi({
        jsApiList: ["getLocation"],
        success(res) {
          if (res.checkResult.getLocation === false) {
            const message =
              "你的微信版本太低，不支持微信JS接口，请升级到最新的微信版本！";
            console.log(message);
          } else {
            wx.getLocation({
              type: 'wgs84',
              success: (res) => {
                console.log("getLocation res=", res)
                const BMap = window.BMap
                const ggPoint = new BMap.Point(res.longitude, res.latitude)
                var convertor = new BMap.Convertor();
                var pointArr = [];
                pointArr.push(ggPoint);
                const geoc = new BMap.Geocoder()
                convertor.translate(pointArr, 1, 5, (res) => {
                  if (res.status === 0) {
                    that.postData.lon = res.points[0].lng
                    that.postData.lat = res.points[0].lat
                    geoc.getLocation(res.points[0], function (rs) {
                      console.log(rs)
                      if (rs) {
                        that.setState({
                          address: rs.address
                        })
                        that.postData.address = rs.address
                      }
                      that.save()
                    });
                    //  that.save()
                  } else {
                    that.save()
                  }
                })
              },
              error: (error) => {
                that.handleLocationError(error, that.save());
              }
            })
          }
        },
      })
    })
    wx.error(function (res) {
      console.log(res, 'res')
    })


  }

  // 备注信息
  handleRemarkChange = (event) => {
    this.setState({ remark: event.target.value });
  }

  // 更换配件信息
  handleReplacementParts = (event) => {
    this.setState({ replacementParts: event.target.value });
  }

  handleTaskExecutedChange = (event) => {
    this.setState({
      taskExecuted: event.target.checked
    })
  }

  // 关签名弹窗
  handleCloseSignature = (v) => {
    console.log(v)
    this.setState({
      ['openSignature' + v]: false
    })
  }








  render() {
    const { detail, scenePhoto, orderPhoto, locationDTOList, showJuliDialog, showDialog, showStartDialog, peoples, peopleList, juli, taskExecuted } = this.state
    const showAssignTask = hasPendingAssignTask(detail)

    return (

      <div className="workOrderDetails">
        <div className="top">
          <ul>
            <li>
              工单编号<span>{detail.orderNo}</span>
            </li>
            <li>
              电梯编码<span>{detail.liftCode}</span>
            </li>
            <li>
              电梯位置<span>{detail.liftLocation}</span>
            </li>
            <li>
              计划时间<span>{detail.planTime}</span>
            </li>
            <li>
              保养类型<span>{detail.maintainTypeName}</span>
            </li>
            {
              showAssignTask ? (
                <li>
                  待执行任务<span>{detail.assignTaskName}</span>
                </li>
              ) : ''
            }
            <li>
              客户等级<span>{detail.grade}</span>
            </li>
            <li>
              {detail.status >= 4 ? (
                <>
                  保养结束<span style={{ backgroundColor: '#999' }}>已结束</span>
                </>
              ) : detail.maintainState == 0 ? (
                <>
                  首次保养<span style={{ backgroundColor: '#52c41a' }}>首次</span>
                </>
              ) : (
                <>
                  继续保养<span style={{ backgroundColor: '#faad14' }}>继续</span>
                </>
              )}
            </li>
            <li>
              距&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;离<b>&nbsp;&nbsp;{juli === null ? '--' : juli}</b>
              <span onClick={this.reset}>刷新</span>
            </li>
          </ul>
        </div>
        <WhiteSpace />
        <div className="bottom">
          <Tabs list={this.state.locationDTOListName} changeTab={this.changeTab} onRef={this.onTabsRef} />
          <ul className="bottomItem">
            <li><i></i><span>正常</span></li>
            <li><i></i><span>出错</span></li>
            <li><i></i><span>无此项</span></li>
            <li><i></i><span>已整改</span></li>
            <li><i></i><span>已更换</span></li>
            <li><i style={{ backgroundColor: '#ccc' }}></i><span>待提交</span></li>
          </ul>
          <div className="mainSwiperBox">
            <MainSwiper status={this.state.status} onRef={this.onMainSwiperRef} list={locationDTOList} touchIndex={this.touchIndex} />
          </div>
          <div className="textAreaBox">
            <h6>备注信息</h6>
            <textarea placeholder="无" disabled={this.state.status === 4} value={this.state.remark} onChange={this.handleRemarkChange} />
          </div>
          <div className="textAreaBox">
            <h6>更换配件信息</h6>
            <textarea placeholder="无" disabled={this.state.status === 4} value={this.state.replacementParts} onChange={this.handleReplacementParts} />
          </div>
          <div className="textAreaBox moreAddBox">
            <h6 onClick={() => this.addItem('p')}>协同人员 +</h6>
            {
              peoples.map((item) => <div key={item.gid}>
                <Select label="nickname" handleChoose={(v) => this.handleChoose(v, item, 'p')} handleFocus={() => this.handleFocus('p')} valueKey="userId" chooseData={item} search={(v) => this.handleSearch(v, 'p')} list={peopleList} />
                <a href="javascript:;" onClick={() => this.showSig(item)}>{item.imageUrl ? '已签名' : '签名'}</a>
                <span onClick={() => this.deleteItem(item.gid, 'p')}>-</span>
              </div>)
            }
          </div>
          {
            this.state.status === 4 && !scenePhoto.length ? "" : (
              <div className="fileUploadBox">
                <h6>现场照片</h6>
                <ImagePicker
                  className={this.state.status === 4 ? "displayClose" : ""}
                  files={scenePhoto}
                  onChange={this.scenePhotoChange}
                  selectable={scenePhoto.length < 5 && this.state.status !== 4}
                  multiple={true}
                  accept="image/gif,image/jpeg,image/jpg,image/png"
                />
              </div>
            )
          }

          {
            this.state.status === 4 && !orderPhoto.length ? "" : (
              <div className="fileUploadBox">
                <h6>工单照片</h6>
                <ImagePicker
                  className={this.state.status === 4 ? "displayClose" : ""}
                  files={orderPhoto}
                  onChange={this.orderPhotoChange}
                  selectable={orderPhoto.length < 5 && this.state.status !== 4}
                  multiple={true}
                  accept="image/gif,image/jpeg,image/jpg,image/png"
                />
              </div>)
          }

          {/* 视频上传组件 */}
          {
            (this.state.status === 4 && !this.state.videoFiles.length) || !this.state.detail.videoStatus ? "" : (
              <div className="fileUploadBox">
                <h6>视频上传</h6>
                {this.state.detail.videoParamList && this.state.detail.videoParamList.map((videoParam, index) => {
                  // 查找当前视频项是否已有上传的视频
                  const existingVideo = this.state.videoFiles.find(v => v.videoTitle === videoParam.videoTitle);
                  const hasVideo = existingVideo || videoParam.videoUrl;

                  return (
                    <div key={index} className="videoItemContainer">
                      <h6>{videoParam.videoTitle || `视频${index + 1}`}</h6>
                      <VideoUploader
                        videoFiles={hasVideo ? [{
                          id: index,
                          url: existingVideo ? (existingVideo.videoUrl || existingVideo.url) : videoParam.videoUrl,
                          videoUrl: existingVideo ? (existingVideo.videoUrl || existingVideo.url) : videoParam.videoUrl,
                          videoTitle: videoParam.videoTitle || `视频${index + 1}`,
                          name: videoParam.videoTitle || `视频${index + 1}`
                        }] : []}
                        maxCount={1}
                        disabled={this.state.status === 4}
                        onUpload={uploadFile}
                        onChange={(videoData) => {
                          const newVideoFiles = [...this.state.videoFiles];
                          const existingIndex = newVideoFiles.findIndex(v => v.videoTitle === videoParam.videoTitle);

                          if (existingIndex !== -1) {
                            // 更新现有视频
                            if (videoData.videoFiles && videoData.videoFiles.length > 0) {
                              newVideoFiles[existingIndex] = {
                                ...videoData.videoFiles[0],
                                videoTitle: videoParam.videoTitle || `视频${index + 1}`
                              };
                            } else {
                              // 如果删除了视频
                              newVideoFiles.splice(existingIndex, 1);
                            }
                          } else if (videoData.videoFiles && videoData.videoFiles.length > 0) {
                            // 添加新视频
                            newVideoFiles.push({
                              ...videoData.videoFiles[0],
                              videoTitle: videoParam.videoTitle || `视频${index + 1}`
                            });
                          }

                          this.setState({ videoFiles: newVideoFiles });
                        }}
                      />
                    </div>
                  );
                })}
              </div>
            )
          }

          {
            this.state.signatureImage.map(item => {
              return (
                <div className="fileUploadBox" key={item.id}>
                  <h6>处理人</h6>
                  <img className="signatureImage" src={item.imageUrl} alt="" />
                </div>
              )
            })
          }
        </div>
        {
          this.state.status === 4 ? '' : (
            <div>
              {
                showAssignTask ? (
                  <label className="taskExecutedBox">
                    <input type="checkbox" checked={taskExecuted} onChange={this.handleTaskExecutedChange} />
                    <span>完成本次指派任务</span>
                  </label>
                ) : ''
              }
              <div className="footer" >
                <div onClick={this.liveSubmit}>中途离开</div>
                <div onClick={this.clickSubmit}>提交</div>
              </div>
              <Drawer direction="bottom" handleClose={() => this.handleClose(1)} open={this.state.open1}>
                <Signature title="本人签字" getSignature={this.getSignature} />
              </Drawer>
              <Drawer direction="bottom" handleClose={() => this.handleClose(2)} open={this.state.open2}>
                <Signature title="客户签字" getSignature={this.getSignature2} />
              </Drawer>
              <Lodding animating={this.state.animating} />
            </div>
          )
        }
        {
          this.state.showTimeDialog ? <Dialog handleCancle={this.handleCancle} handleConfirm={this.handleCancle} title="维保提示" content={this.state.showTimeMsg} /> : ''
        }
        {
          this.state.showJuliDialog ? <Dialog handleCancle={this.handleCancle} handleConfirm={this.handleCancle} title="维保提示" content={"异地不能开始保养，距离" + juli} /> : ''
        }
        {
          showDialog ? <Dialog handleCancle={this.handleCancle} handleConfirm={this.handleConfirm} title="维保提示" content="当前日期不是计划保养时间是否继续保养？" /> : ''
        }
        {
          showStartDialog ? <Dialog handleCancle={this.handleCancle} handleConfirm={this.handleStartConfirm} title="维保提示" content="是否确定开始保养？" /> : null
        }
        {
          this.state.showForceSubmitDialog ? <Dialog handleCancle={this.handleForceSubmitCancel} handleConfirm={this.handleForceSubmitConfirm} title="提示" content={this.state.forceSubmitMsg} /> : null
        }
        <Drawer direction="bottom" handleClose={() => { this.handleCloseSignature(3) }} open={this.state.openSignature3}>
          <Signature title="协同人签名" getSignature={this.getSignature3} />
        </Drawer>
      </div>
    )
  }
}

export default connect()(WorkOrderDetails);
